import React from "react";

const Customer_profile = () => {
  return (
    <>
      {/* customer review starts here */}
      <div className="customer-review-wrapper">
        <div className="heading-wrapper">
          <h3>Customer Reviews</h3>
          <a href="#">View More</a>
        </div>
        <div className="ratings-wrap">
          <div className="single-rate">
            <div className="progress-wrapper">
              <h6>5 Star</h6>
              <div className="pro">
                <div className="per" style={{ width: "24%" }}></div>
              </div>
            </div>
            <div className="percent">
              <h6>24 %</h6>
            </div>
          </div>
          <div className="single-rate">
            <div className="progress-wrapper">
              <h6>4 Star</h6>
              <div className="pro">
                <div className="per" style={{ width: "50%" }}></div>
              </div>
            </div>
            <div className="percent">
              <h6>50 %</h6>
            </div>
          </div>
        </div>
      </div>
      <div className="btns-wrapper">
        <a href="#" className="btn btn-green">
          <i className="fa-brands fa-cc-stripe"></i>
          <span>Complete on boarding</span>{" "}
        </a>
        <a href="#" className="btn btn-yellow">
          <i className="fa-solid fa-arrow-right-from-bracket"></i>
          <span>Log Out</span>{" "}
        </a>
      </div>
      {/* customer review ends here */}
    </>
  );
};

export default Customer_profile;
